'use strict';

angular.module('ClinicApp').directive('appointmentHistoryAutomaticallyVerified', function(BillingContestedConstants, OpencareConstants) {
  return {
    templateUrl: '/views/directives/_appointment-history-automatically-verified.html',
    scope: {
      appointment: '=',
      onclick: '=',
    },
    link: function($scope) {
      $scope.getState = function() {
        switch (_.get($scope.appointment, 'metadata.billingContested')) {
          case BillingContestedConstants.CONTESTED:
            return 'CONTESTED';
          case BillingContestedConstants.RESOLVED:
            switch (_.get($scope.appointment, 'metadata.billingStatus')) {
              case OpencareConstants.billingStates.NOT_BILLED:
              case OpencareConstants.billingStates.REFUNDED:
              case OpencareConstants.billingStates.TRIAL:
                return 'APPROVED';
              case OpencareConstants.billingStates.TO_BILL:
              case OpencareConstants.billingStates.INVOICE_ISSUED:
              case OpencareConstants.billingStates.BILLED:
                return 'REJECTED';
            }
            break;
          default:
            return 'DEFAULT';
        }
      };
    },
  };
});
